import Glide, { Swipe, Controls } from '@glidejs/glide/dist/glide.modular.esm';

document.addEventListener('DOMContentLoaded', function () {
	if (document.querySelector('.glide')) {
		const banner = document.querySelector('.glide');
		const pauseOnHover = Boolean(banner.dataset.pauseOnHover);

		const glide = new Glide(banner, {
			autoplay: false,
			perView: 1
		}).mount({ Swipe, Controls });

		const slides = document.querySelectorAll('.glide__slide');
		let timer = null;

		function getDurationForSlide(index) {
			const slide = slides[index];
			const duration = slide?.dataset?.duration;
			return duration ? parseInt(duration) : 5000;
		}

		function animateProgress(index, duration) {
			const bars = document.querySelectorAll('.progress-fill');

			if (bars.length) {
				bars.forEach((bar) => {
					bar.style.transition = 'none';
					bar.style.width = '0%';
				});

				const currentBar = bars[index];
				currentBar.style.transition = `width ${duration}ms linear`;
				void currentBar.offsetWidth;
				currentBar.style.width = '100%';
			}
		}

		function scheduleNextSlide(index) {
			clearTimeout(timer);

			const currentSlide = slides[index];
			const hasVideo = currentSlide.querySelector('iframe');

			if (hasVideo) {
				return;
			}

			const duration = getDurationForSlide(index);
			animateProgress(index, duration);

			timer = setTimeout(() => {
				glide.go('>');
			}, duration);
		}

		glide.on(['mount.after', 'run.after'], () => {
			const currentIndex = glide.index;
			scheduleNextSlide(currentIndex);
		});

		if (pauseOnHover) {
			const slideContainer = document.querySelector('.banner');
			slideContainer.addEventListener('mouseenter', () =>
				clearTimeout(timer)
			);
			slideContainer.addEventListener('mouseleave', () =>
				scheduleNextSlide(glide.index)
			);
		}

		const bgSlides = document.querySelectorAll('.glide__slide.slide-image');
		bgSlides.forEach((slide) => {
			const mobileImage = slide.getAttribute('data-mobile-image');
			const tabletImage = slide.getAttribute('data-tablet-image');
			const desktopImage = slide.getAttribute('data-desktop-image');

			function setBackgroundImage() {
				let bgImage = desktopImage;

				if (window.innerWidth < 768) {
					bgImage = mobileImage || tabletImage || desktopImage;
				} else if (window.innerWidth < 1024) {
					bgImage = tabletImage || desktopImage;
				}

				slide.style.backgroundImage = `url(${bgImage})`;
			}

			setBackgroundImage();
			window.addEventListener('resize', setBackgroundImage);
		});
	}
});

document.querySelectorAll('.play-button').forEach((button) => {
	button.addEventListener('click', function (e) {
		const placeholder = this.closest('.video--placeholder');
		const videoId = placeholder.dataset.videoId;

		const iframe = document.createElement('iframe');
		iframe.setAttribute(
			'src',
			`https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0&modestbranding=1&rel=0`
		);
		iframe.setAttribute('allow', 'autoplay; encrypted-media');
		iframe.setAttribute('allowfullscreen', '');
		iframe.setAttribute('frameborder', '0');
		iframe.style.width = '100%';
		iframe.style.height = '100%';

		placeholder.innerHTML = '';
		placeholder.appendChild(iframe);
	});
});
